type Listener = () => void;

export class RefreshActivity {
  private active = 0;
  private readonly listeners = new Set<Listener>();

  subscribe = (listener: Listener): (() => void) => {
    this.listeners.add(listener);
    return () => this.listeners.delete(listener);
  };

  getSnapshot = (): boolean => this.active > 0;

  begin(): () => void {
    this.active += 1;
    this.emit();
    let finished = false;
    return () => {
      if (finished) return;
      finished = true;
      this.active -= 1;
      this.emit();
    };
  }

  private emit(): void {
    for (const listener of this.listeners) listener();
  }
}

export const refreshActivity = new RefreshActivity();
